module.exports = __webpack_public_path__ + "static/media/auto.1f34ec84.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/auto.png
// module id = 787
// module chunks = 0